import AttendanceAdapter from './base';

export default class RecordsByLearner extends AttendanceAdapter {
  modelNamePlural = 'recordsByLearners';
}
